import {Trans} from '@lingui/macro';
import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
  virtualTableRowOffset,
} from '../../components/common/table/helpers/tableHelpers';
import {TableColumn} from '../../components/common/table/tableColumn';

export enum CirclesTableColumnsEnum {
  NAME = 'name',
  TEAMMATES = 'teammates',
  CREATED_AT = 'created_at',
}

export const circlesTableColumns: ReadonlyArray<TableColumn<CirclesTableColumnsEnum>> = [
  {
    id: CirclesTableColumnsEnum.NAME,
    type: CirclesTableColumnsEnum.NAME,
    title: <Trans id="circles-table-column-name">Group name</Trans>,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: 330 - virtualTableRowOffset,
      },
    },
  },
  {
    id: CirclesTableColumnsEnum.TEAMMATES,
    type: CirclesTableColumnsEnum.TEAMMATES,
    title: <Trans id="circles-table-column-teammates">Members</Trans>,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        width: 173,
      },
    },
  },
  {
    id: CirclesTableColumnsEnum.CREATED_AT,
    type: CirclesTableColumnsEnum.CREATED_AT,
    cellType: VirtualTableColumnCellsEnum.DATE,
    title: <Trans id="circles-table-column-create-at">Date created</Trans>,
    settings: {
      cellWidth: {
        width: 152,
      },
    },
  },
];
